import script from "./StateAppointmentTypeQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./StateAppointmentTypeQuestion.vue?vue&type=script&setup=true&lang=js"

import _style_0 from "./StateAppointmentTypeQuestion.vue?vue&type=style&index=0&id=73842124&inline&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]],['__scopeId',"data-v-73842124"]])

export default __exports__